<template>
  <div class="home-hot-shop" v-if="data" :style="'background-image:url('+data.img+');'">
    <div class="title">
      {{ data.title }}
    </div>
    <div v-html="data.content" class="content van-multi-ellipsis--l3" />
    <div class="tomore" @click="$router.push({ name: 'aboutus' }, () => {})">更多<van-icon name="arrow" /></div>
  </div>
</template>

<script>
export default {
  name: 'HotShopsView',
  data () {
    return {
      data: null
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    async getData () {
      await this.$http({
        method: 'post',
        url: 'getContentIndex'
      }).then(res => {
        this.data = res.data.default_info
        // this.data.content += '<p>222222222222222222222222222</p><p>222222222222222222222222222</p><p>222222222222222222222222222</p><p>222222222222222222222222222</p>'
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.home-hot-shop {
  margin: 10px 10px 0px;
  padding: 15px 0px 0px;
  color: #fff;
  background-size: cover;
  background-position: center;
  border-radius: 8px;
  box-shadow: 8px 8px 16px rgba(0, 0, 0, 0.3);
  .title {
    text-align: center;
    font-size: 20px;
    font-weight: 600;
    border-bottom: 1px solid #dcdee0;
    padding-bottom: 10px;
    margin: 0 10px;
  }
  .content {
    margin: 20px 15px;
    overflow: hidden;
    max-height: 94px;
  display: -webkit-box;           /* 必須：將對象作為彈性伸縮盒子模型顯示 */
  -webkit-box-orient: vertical;  /* 必須：設置伸縮盒子的子元素排列方式為垂直 */
  -webkit-line-clamp: 3;          /* 必須：限制顯示的文本行數為 3 行 */
  overflow: hidden;               /* 必須：隱藏超出盒子的內容 */
  text-overflow: ellipsis;        /* 選填：當文字溢出時顯示省略標記 */
  word-break: break-all;          /* 建議：強制英文/數字單字換行，避免撐破佈局 */
  }
  .tomore {
    text-align: right;
    padding: 0px 15px 10px;
    font-size: 14px;
    font-weight: 550;
  }
}
</style>
